import { IGNORED, Test } from "oc-e2e-testrunner";
import { assertEqualsBestellliste, resetArrangement } from "./utils";

export default {
  name: "TestElementeFremderSerienEntfernen",
};

export const testRemoveSystemDoppeltorFürXLSerie: Test = async () => {
  // ArtikelID 2499 wurde zu 2499_wpc_classic_xl umbenannt (Metadaten-Änderung)
  resetArrangement();
  const agt = APP.arrangement;
  const breite = 20;
  agt.grundriss.setStandardForm("Strecke", [breite]);
  agt.update3d();
  const s = agt.segmente[0];
  let x = 0;
  [
    {
      form: "Einzeltor",
      füllungAuswahlwert: "SYSTEM WPC CLASSIC Grau",
    },
    {
      form: "Rechteck",
      füllungAuswahlwert: "SYSTEM WPC CLASSIC Grau",
    },
    {
      form: "Doppeltor",
      füllungAuswahlwert: "SYSTEM WPC CLASSIC Grau",
    },
    {
      form: "Rechteck",
      füllungAuswahlwert: "SYSTEM WPC CLASSIC Grau",
    },
    {
      form: "Einzeltor",
      füllungAuswahlwert: "SYSTEM WPC CLASSIC Grau",
    },
    {
      form: "Rechteck",
      füllungAuswahlwert: "SYSTEM FLOW Anthrazit solid",
    },
  ].forEach((json) => {
    const element = agt.createElementFromJson(json);
    s.addPart(element);
    s.setX(element, 0, x);
    x += element.breite + 0.4;
  });
  agt.update3d();
  assertEqualsBestellliste(
    [
      {
        ArtikelID: "2576",
        Anzahl: 2,
      },
      {
        ArtikelID: "2740",
        Anzahl: 1,
      },
      {
        ArtikelID: "2341",
        Anzahl: 1,
      },
      {
        ArtikelID: "2314",
        Anzahl: 1,
      },
      {
        ArtikelID: "2499_wpc_classic_xl",
        Anzahl: 2,
        Mass: "178 x 180 cm",
      },
      {
        ArtikelID: "2059",
        Anzahl: 2,
      },
      {
        ArtikelID: "1251",
        Anzahl: 2,
      },
      {
        ArtikelID: "2550",
        Anzahl: 2,
      },
      {
        ArtikelID: "2036",
        Anzahl: 1,
        Mass: "177 x 180 cm",
      },
      {
        ArtikelID: "2018",
        Anzahl: 1,
      },
      {
        ArtikelID: "1251",
        Anzahl: 1,
      },
      {
        ArtikelID: "2550",
        Anzahl: 1,
      },
      {
        ArtikelID: "2777",
        Anzahl: 5,
      },
      {
        ArtikelID: "1398",
        Anzahl: 1,
      },
    ],
    agt.bestellliste
  );
  const inspiration = APP.richMetadata.findAuswahlwert("Inspiration XL Holzzaun")?.Inspiration[0];
  agt.inspiration = inspiration;
  APP.arrangement.changeSelectedZaunElemente({
    füllungAuswahlwert: inspiration.Füllung,
  });
  agt.update3d();
  assertEqualsBestellliste(
    [
      {
        ArtikelID: "1156",
        Anzahl: 2,
      },
      {
        ArtikelID: "1614",
        Anzahl: 1,
      },
      {
        ArtikelID: "1590",
        Anzahl: 3,
      },
      {
        ArtikelID: "1147",
        Anzahl: 2,
      },
      {
        ArtikelID: "3789",
        Anzahl: 2,
      },
      {
        ArtikelID: "2059",
        Anzahl: 2,
      },
      {
        ArtikelID: "1251",
        Anzahl: 2,
      },
      {
        ArtikelID: "2550",
        Anzahl: 2,
      },
      {
        ArtikelID: "1781",
        Anzahl: 5,
      },
      {
        ArtikelID: "2096",
        Anzahl: 3,
      },
    ],
    agt.bestellliste
  );
};

export const testRemoveSystemDreifachtorFürXLSerie: Test = async () => {
  // ArtikelID 2499 wurde zu 2499_wpc_classic_xl umbenannt (Metadaten-Änderung)
  resetArrangement();
  const agt = APP.arrangement;
  agt.verteilungsstrategieAuswahlwert_ = APP.richMetadata.findAuswahlwert("Individuell");
  const breite = 20;
  agt.grundriss.setStandardForm("Strecke", [breite]);
  agt.update3d();
  const s = agt.segmente[0];
  let x = 0;
  [
    {
      form: "Einzeltor",
      füllungAuswahlwert: "SYSTEM WPC CLASSIC Grau",
      öffnungAuswahlwert: "Öffnung_nach_außen",
    },
    {
      form: "Doppeltor",
      füllungAuswahlwert: "SYSTEM WPC CLASSIC Grau",
    },
  ].forEach((json) => {
    const element = agt.createElementFromJson(json);
    s.addPart(element);
    s.setX(element, 0, x);
    x += element.breite + 0.4;
  });
  agt.update3d();
  assertEqualsBestellliste(
    [
      {
        ArtikelID: "2499_wpc_classic_xl",
        Anzahl: 1,
        Mass: "Dreifachtor 177 x 180 cm + 178 x 180 cm",
      },
      {
        ArtikelID: "2036",
        Anzahl: 1,
        Mass: "Dreifachtor 177 x 180 cm + 178 x 180 cm",
      },
      {
        ArtikelID: "2625_anthrazit",
        Anzahl: 1,
      },
      {
        ArtikelID: "1251",
        Anzahl: 2,
      },
      {
        ArtikelID: "2550",
        Anzahl: 2,
      },
    ],
    agt.bestellliste
  );
  const inspiration = APP.richMetadata.findAuswahlwert("Inspiration XL Holzzaun")?.Inspiration[0];
  agt.inspiration = inspiration;

  // FIXME das hier ist wichtig, da speziell bei Toren die Füllung ansonsten auf WPC zurückgestellt wird,
  // aufgrund des fehlenden füllungAuswahlwertIndividualisiert - Flags
  APP.arrangement.setSelectedObjects(APP.arrangement.getElemente());

  APP.arrangement.changeSelectedZaunElemente({
    füllungAuswahlwert: inspiration.Füllung,
  });
  agt.update3d();
  // Das Einzeltor bleibt übrig
  assertEqualsBestellliste(
    [
      {
        ArtikelID: "1147",
        Anzahl: 1,
      },
      {
        ArtikelID: "3789",
        Anzahl: 1,
      },
      {
        ArtikelID: "2059",
        Anzahl: 1,
      },
      {
        ArtikelID: "1251",
        Anzahl: 1,
      },
      {
        ArtikelID: "2550",
        Anzahl: 1,
      },
      {
        ArtikelID: "1781",
        Anzahl: 1,
      },
    ],
    agt.bestellliste
  );
};
